import { FormControlLabel, Switch } from '@mui/material';
import React from 'react';

type GroupMessageControlledSwitchProps = {
  label: string;

  setToggleState: React.Dispatch<React.SetStateAction<boolean>>;
  toggleState: boolean;
};

export const GroupMessageControlledSwitch = (props: GroupMessageControlledSwitchProps) => {
  const { label, setToggleState, toggleState } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setToggleState(event.target.checked);
  };

  return (
    <FormControlLabel
      disableTypography
      label={label}
      sx={{ ml: 0.5, fontSize: (theme) => theme.typography.body2.fontSize }}
      control={<Switch checked={toggleState} onChange={handleChange} />}
    />
  );
};
